import api from "../../utils/Api";
import history from "../../utils/history";
import {
  USERS_LOGIN_REQUEST,
  USERS_LOGIN_SUCCESS,
  USERS_LOGIN_ERROR,
} from "./loginTypes";
import store from "../store";
import { fetchPermissions} from "../../redux";
import { socketInitialize } from "../../services/SocketServices";
export const loginRequest = () => {
  return {
    type: USERS_LOGIN_REQUEST,
  };
};

export const loginUsersSuccess = (users) => {
  return {
    type: USERS_LOGIN_SUCCESS,
    payload: users,
  };
};

export const loginUsersFailure = (error) => {
  return {
    type: USERS_LOGIN_ERROR,
    payload: error,
  };
};

export const signIn = (data) => {
  return async (dispatch) => {
    dispatch(loginRequest());
    try {
      const response = await api.post("user/login", {
        email: data.email,
        password: data.password,
      });
      const usersData = response.data.token;
      dispatch(loginUsersSuccess(usersData));
      const userInfo = {
        token: response.data.token,
        isLoggenIn: true,
        systemRole: response.data.user.role_id,
        name:
          response.data.user.first_name + " " + response.data.user.last_name,
        role: response.data.user.role_name,
        email:response.data.user.email,
        approver: response.data.user.approver,
        user_id: response.data.user.user_id,
        contact_id: response.data.user.related_party_id?
        response.data.user.related_party_id:null
      };
      //set JWT token here
      localStorage.setItem("USER_INFO", JSON.stringify(userInfo));
      socketInitialize();
      //calling role permissions data
      await dispatch(fetchPermissions(userInfo.systemRole));
      history.push("/dashboard");
    } catch (error) {
      console.log("Redux error - ", error.response.data.message);
      const errorMsg = error.response.data.message;
      dispatch(loginUsersFailure(errorMsg));
    }
  };
};
